import { useEffect, useState } from "react";

export interface VisaFakturaState {
    konteringUnlockReady: boolean;
    konteringLockReady: boolean;
}

function parseData(data: any): VisaFakturaState {
    const retval = {} as VisaFakturaState;

    if (!data)
        return retval;

    return data;
}

// window.InvoicePageState är ett serialiserat objekt i VisaFaktura.aspx. Det serialiseras till camelCase.
export function useInvoicePageState() {
    const [data, setData] = useState<VisaFakturaState | undefined>(null);

    useEffect(() => {
        const tmp = parseData(window.InvoicePageState);
        setData(tmp);
    }, [window.JSRpcPlaner]);

    return data;
}
